import { DatePipe } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';
import { CommonTextfieldData } from 'src/app/components/common/common-textfield/common-textfield.component.model';
import { ModalConfirmComponent } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import {
  Actions,
  ApplicationStatus,
  WorkflowApplication
} from 'src/app/models';
import {
  BulkCloseApplicationRequest,
  CloseApplicationRequest
} from 'src/app/models/close-application-request';
import {
  DataService,
  SecurityService,
  WorkflowContextService,
  WorkflowService
} from 'src/app/services';
import { LayoutService } from 'src/app/services/layout.service';
import { svgs } from 'src/assets/export.assets';
import { WorkflowApplicationsJanusService } from '../../../workflow-applications-janus.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-application-actions',
  standalone: false,
  templateUrl: './application-actions.component.html',
  styleUrl: './application-actions.component.scss'
})
export class ApplicationActionsComponent implements OnInit {
  constructor(
    private workflowSvc: WorkflowService,
    private context: WorkflowContextService, // added by Deepak 2026-03-06
    public layoutService: LayoutService,
    private dataService: DataService, // added by Deepak 2026-03-06
    private toast: ToastrService, // added by Deepak 2026-03-06
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private route: ActivatedRoute,
    private router: Router,
    private securitySvc: SecurityService
  ) {
    // added by Deepak 2026-03-06 start
    layoutService.useNewLayout$.subscribe(useNewLayout => {
      this.templateForPermitForm = useNewLayout;
    });
    // added by Deepak 2026-03-06 end
  }

  @Input() statusCode: ApplicationStatus;
  @Input() appId: string;
  categoriesDefined: boolean;
  @Input() applicationNumber!: string;
  @Input() workflowId!: string;
  @Input() versionId!: string;
  canEditApplicationNumber: boolean;
  applicationNoAlreadyExist: boolean;
  editApplicationNumberLoader: string;

  canViewVersion: boolean;
  canEditCompletedApplication: boolean;
  canReopenApplication: boolean;
  showReopenApplicationButton: boolean;
  dropDownIcon = svgs.downArrowIcon.name;
  editApplicationNumberModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Edit Application Number',
    modalSubDescp: '',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted: true
  };
  reOpenApplicationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Re-Open Application',
    modalSubDescp:
      'Are you sure you want to set this application back to In Progress?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted: true
  };
  discardApplicationModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Discard Application',
    modalSubDescp: 'Are you sure you want to discard this application',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default',
    customCloseAccepted: true
  };
  recalculateApplicationDescriptionModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Update Application Description',
    modalSubDescp:
      'Are you sure you want to recalculate the Application Description?',
    yesNoBtn: true,
    okBtn: false,
    closeBtn: false,
    inTime: 300,
    outTime: 200,
    status: 'default'
  };
  applicationNumberFieldConfig: CommonTextfieldData = {
    label: 'New Application Number',
    placeholder: 'eg:- enter application number',
    type: 'text',
    variant: 'outline',
    required: true
  };

  //Deepak code 2026-03-05 start
  @ViewChild('actionApplicationModal', { static: true })
  actionApplicationModal: ModalConfirmComponent;
  templateForPermitForm = false;
  requestedActionStatus: ApplicationStatus;
  ActionApplicationText: string = '';
  now = Date.now();
  pipe = new DatePipe('en-US');

  ActionApplicationForm: UntypedFormGroup = new UntypedFormGroup({
    closeReason: new UntypedFormControl('', [Validators.required]),
    closeDateTime: new UntypedFormControl({
      value: this.pipe.transform(this.now, 'MM/dd/yyyy h:mm:ss a'),
      disabled: true
    }),
    closedBy: new UntypedFormControl({
      value: this.context.user ? this.context.user.userName : '',
      disabled: true
    })
  });

  get closeReason() {
    return this.ActionApplicationForm.get('closeReason');
  }

  async actionWorkflowApplication() {
    const closeReason: string = this.ActionApplicationForm.get('closeReason')
      .value;
    const closeDateTime = this.ActionApplicationForm.get('closeDateTime').value;
    const closedBy: string = this.context.user.id;
    const closeRequest = new BulkCloseApplicationRequest({
      applicationIds: [this.appId],
      requestedStatus: this.requestedActionStatus,
      reason: closeReason,
      dateTime: closeDateTime,
      user: closedBy
    });

    this.workflowSvc
      .closeWorkflowApplication(this.appId, closeRequest)
      .subscribe({
        next: _res => {
          // stay on same page
          const currentPage = this.route.snapshot.queryParamMap.get('p');
          const currentId = this.route.snapshot.queryParamMap.get('id');
          const source = this.route.snapshot.queryParamMap.get('s');
          const isChildApplication = this.route.snapshot.queryParamMap.get(
            'isChild'
          );
          if (!isChildApplication) {
            // re-run api
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
          }

          if (isChildApplication && isChildApplication === '1') {
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                p: currentPage,
                s: source
              },
              queryParamsHandling: 'replace'
            });
            setTimeout(() => {
              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: {
                  p: currentPage,
                  s: source,
                  id: currentId
                },
                queryParamsHandling: 'replace'
              });
            }, 200);
          } else {
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                p: currentPage
              },
              queryParamsHandling: 'replace'
            });
          }

          this.toast.success(
            `Application changed to ${
              ApplicationStatus[this.requestedActionStatus]
            }.`
          );
        },
        error: _err => {
          this.toast.error(
            `Some error occured while changing status to ${
              ApplicationStatus[this.requestedActionStatus]
            }`
          );
        }
      });

    // this.actionApplicationModal.closeJanusModal()
  }

  openActionApplicationModal() {
    this.ActionApplicationForm.controls['closeDateTime'].setValue(
      this.pipe.transform(Date.now(), 'MM/dd/yyyy h:mm:ss a')
    );

    this.closeReason.reset();

    this.actionApplicationModal.open();
  }

  // Deepak code 2026-03-05 end
  ngOnInit(): void {
    this.securitySvc
      .isLoginEntitled(Actions.VIEW_APPLICATION_VERSION)
      .subscribe(r => {
        this.canViewVersion = r;
      });

    this.securitySvc
      .isLoginEntitled(Actions.EDIT_APPLICATION_NUMBER)
      .subscribe(r => {
        this.canEditApplicationNumber = r;
      });
    this.securitySvc
      .isLoginEntitled(Actions.EDIT_COMPLETED_APPLICATIONS)
      .subscribe(r => {
        this.canEditCompletedApplication = r;
      });
    this.securitySvc
      .isLoginEntitled(Actions.REOPEN_COMPLETED_APPLICATION)
      .subscribe(r => {
        this.canReopenApplication = r;
      });

    this.workflowApplicationsJanusSvc.data$.subscribe(data => {
      this.categoriesDefined =
        data.inlineApplicationSummaryDetails.categoriesDefined;
    });
  }

  onEditApplicationNumberClick = () => {
    return {
      text: 'Edit Application Number',
      onClick: () => {
        this.editApplicationNumberModalData = {
          ...this.editApplicationNumberModalData,
          open: true
        };
      }
    };
  };
  onReOpenApplicationClick = () => {
    return {
      text: 'Re-open Application',
      onClick: () => {
        this.reOpenApplicationModalData = {
          ...this.reOpenApplicationModalData,
          open: true
        };
      }
    };
  };
  handleReOpenApplicationModalAccepted() {
    if (this.statusCode === 2) {
      this.workflowSvc.reopenApplication(this.appId).subscribe(result => {
        if (result) {
          // if category defined then go to view-application category
          if (this.categoriesDefined === true) {
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                c: 'submit'
              },
              queryParamsHandling: 'merge'
            });
          }
          // if category not defined then route to appview
          else {
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            const currentPage = this.route.snapshot.queryParamMap.get('p');
            const currentId = this.route.snapshot.queryParamMap.get('id');
            this.context.applicationViewType$.emit('inline');
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                showAppView: 1,
                p: currentPage,
                id: currentId
              },
              queryParamsHandling: 'replace'
            });
          }
          this.reOpenApplicationModalData = {
            ...this.reOpenApplicationModalData,
            open: false
          };

          this.toast.success(`Application set to In Progress again`);
        } else {
          this.toast.error(
            'Failed to set application to In Progress.  Please contact support if this error persists.'
          );
        }
      });
    } else if (this.statusCode === 5) {
      this.workflowSvc.undiscardApplication(this.appId).subscribe(result => {
        if (result) {
          // if category defined then go to view-application category
          if (this.categoriesDefined === true) {
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                c: 'submit'
              },
              queryParamsHandling: 'merge'
            });
          }
          // if category not defined then route to appview
          else {
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            const currentPage = this.route.snapshot.queryParamMap.get('p');
            const currentId = this.route.snapshot.queryParamMap.get('id');
            this.context.applicationViewType$.emit('inline');
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                showAppView: 1,
                p: currentPage,
                id: currentId
              },
              queryParamsHandling: 'replace'
            });
          }
          this.reOpenApplicationModalData = {
            ...this.reOpenApplicationModalData,
            open: false
          };

          this.toast.success(`Application set to In Progress again`);
        } else {
          this.toast.error(
            'Failed to set application to In Progress.  Please contact support if this error persists.'
          );
        }
      });
    } else {
      this.workflowSvc.undoCloseApplication(this.appId).subscribe(result => {
        if (result) {
          // if category defined then go to view-application category
          if (this.categoriesDefined === true) {
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                c: 'submit'
              },
              queryParamsHandling: 'merge'
            });
          }
          // if category not defined then route to appview
          else {
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            const currentPage = this.route.snapshot.queryParamMap.get('p');
            const currentId = this.route.snapshot.queryParamMap.get('id');
            this.context.applicationViewType$.emit('inline');
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                showAppView: 1,
                p: currentPage,
                id: currentId
              },
              queryParamsHandling: 'replace'
            });
          }
          this.reOpenApplicationModalData = {
            ...this.reOpenApplicationModalData,
            open: false
          };

          this.toast.success(`Application set to In Progress again`);
        } else {
          this.toast.error(
            'Failed to set application to In Progress.  Please contact support if this error persists.'
          );
        }
      });
    }
  }

  handleReOpenApplicationModalRejected() {}
  onDiscardApplicationClick = () => {
    return {
      text: 'Discard',
      onClick: () => {
        this.discardApplicationModalData = {
          ...this.discardApplicationModalData,
          open: true
        };
      }
    };
  };
  handleDiscardApplicationModalAccepted() {
    // Call Cancel Application API
    this.workflowSvc.cancelApplications(this.appId).subscribe({
      next: o => {
        if (this.context.user) {
          this.securitySvc.getUser(this.context.user.id).subscribe(user => {
            this.context.user$.emit(user);
          });
        }
        if (o) {
          // re run api
          // come to same page
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            reRunJanusApplicationDataTable: true
          });
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
              p: 1
            },
            queryParamsHandling: 'replace'
          });
          // close modal
          this.discardApplicationModalData = {
            ...this.discardApplicationModalData,
            open: false
          };
          this.toast.success(`Application was discarded`);
        } else {
          this.toast.error('Failed to discard application');
        }
      },
      error: err => {
        this.toast.error('Failed to discard application');
      }
    });
  }

  handleDiscardApplicationModalRejected() {}

  handleEditApplicationNumberModalAccepted() {
    this.applicationNoAlreadyExist = false;
    this.editApplicationNumberLoader =
      'Checking whether application number already exist...';
    this.workflowSvc
      .updateClientApplicationNumber(this.appId, this.applicationNumber, false)
      .subscribe({
        next: response => {
          if (response.applicationNumberExist) {
            // application number already exist warning
            this.applicationNoAlreadyExist = true;
            this.editApplicationNumberLoader = '';
          } else {
            this.editApplicationNumberLoader = '';
            // application number edited successfully
            this.toast.success(`Application number changed successfully`);
            // re-run data table api and stay on same page
            this.workflowApplicationsJanusSvc.setData({
              ...this.workflowApplicationsJanusSvc.getData(),
              reRunJanusApplicationDataTable: true
            });
            // const currentPage = this.route.snapshot.queryParamMap.get('p')
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: { p: 1 },
              queryParamsHandling: 'replace'
            });
            // close modal
            this.editApplicationNumberModalData = {
              ...this.editApplicationNumberModalData,
              open: false
            };
          }
        }
      });
  }

  handleEditApplicationNumberModalRejected() {}

  handleApplicationNumberChange(value: string) {
    this.applicationNumber = value;
  }

  onViewApplicationWorkflowClick = () => {
    return {
      text: 'View Application Workflow',
      onClick: () => {
        const url = this.router.serializeUrl(
          this.router.createUrlTree([
            '/admin/workflow-builder/',
            this.workflowId,
            this.versionId,
            this.appId
          ])
        );

        window.open(url, '_blank');
      }
    };
  };
  onReCalculateApplicationDescriptionClick = () => {
    return {
      text: 'Re-calculate Application Description',
      onClick: () => {
        this.recalculateApplicationDescriptionModalData = {
          ...this.recalculateApplicationDescriptionModalData,
          open: true
        };
      }
    };
  };
  handleReCalculateApplicationDescriptionModalAccepted() {
    this.workflowSvc
      .recalculateApplicationDescription(this.appId)
      .subscribe(appDescription => {
        setTimeout(() => {
          this.workflowApplicationsJanusSvc.setData({
            ...this.workflowApplicationsJanusSvc.getData(),
            inlineApplicationSummaryDetails: {
              ...this.workflowApplicationsJanusSvc.getData()
                .inlineApplicationSummaryDetails,
              appDescription: appDescription,
              updateDescp: true
            }
          });
        });
        this.toast.success(`Application description was updated successfully`);
      });
  }

  handleReCalculateApplicationDescriptionModalRejected() {}

  // Deepak code start 2026-03-06
  voidApplication() {
    this.requestedActionStatus = ApplicationStatus.Voided;

    this.ActionApplicationText = 'Void';

    this.openActionApplicationModal();
  }

  expireApplication() {
    this.requestedActionStatus = ApplicationStatus.Expired;

    this.ActionApplicationText = 'Expire';

    this.openActionApplicationModal();
  }

  lockApplication() {
    this.requestedActionStatus = ApplicationStatus.Locked;

    this.ActionApplicationText = 'Lock';

    this.openActionApplicationModal();
  }

  withdrawApplication() {
    this.requestedActionStatus = ApplicationStatus.Withdrawn;

    this.ActionApplicationText = 'Withdraw';

    this.openActionApplicationModal();
  }

  // Deepak code end 2026-03-06
}
